module.exports = __webpack_public_path__ + "img/tree_grass.cc134672.svg";